import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { X } from 'lucide-react';

export const ImageNode: React.FC<NodeViewProps> = ({ node, deleteNode }) => {
  const alignment = node.attrs['data-alignment'] || 'center';
  const imageId = node.attrs['data-id'];
  
  return (
    <NodeViewWrapper className={`image-container text-${alignment}`}>
      <div className="image-wrapper">
        <img
          src={node.attrs.src}
          alt={node.attrs.alt || ''}
          data-id={imageId}
          data-alignment={alignment}
          style={{
            maxWidth: node.attrs.width ? `${node.attrs.width}px` : '100%',
            height: 'auto'
          }}
        />
        {imageId && (
          <button
            className="delete-button"
            onClick={() => deleteNode()}
            title="Remover imagem"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
    </NodeViewWrapper>
  );
};